import { render, staticRenderFns } from "./VPhotoPreview.vue?vue&type=template&id=2011d954"
import script from "./VPhotoPreview.vue?vue&type=script&lang=js"
export * from "./VPhotoPreview.vue?vue&type=script&lang=js"
import style0 from "./VPhotoPreview.vue?vue&type=style&index=0&id=2011d954&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports